/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Email_ValidationInputs */



/**
* | output |
* | --- |
* | "Please enter your email address to reset password" |
*
* @param {Login_Error_Email_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_email_validation = /** @type {((inputs?: Login_Error_Email_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Email_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez entrer votre adresse email pour réinitialiser le mot de passe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il tuo indirizzo email per reimpostare la password")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите свой адрес электронной почты для сброса пароля.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese su dirección de correo electrónico para restablecer la contraseña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入您的电子邮件地址以重置密码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードをリセットするにはメールアドレスを入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड रीसेट करने के लिए कृपया अपना ईमेल पता दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira seu endereço de e-mail para redefinir a senha.")
	return /** @type {LocalizedString} */ ("Please enter your email address to reset password")
});